import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface OutstandingReviewsByBrand {
  brand: string;
  outstanding: number;
}

export interface OutstandingReviewsResponse {
  brands: OutstandingReviewsByBrand[];
  total: number;
}

export const useOutstandingReviewsByBrand = () => {
  return useQuery<OutstandingReviewsResponse>(
    'outstandingReviewsByBrand',
    async () => {
      const response = await apiClient.get(
        '/api/v1/scraper/statistics/reviews/outstanding-by-brand'
      );
      return response.data;
    },
    {
      refetchInterval: 120000,
      staleTime: 60000,
      cacheTime: 300000,
    }
  );
};
